// extracted by mini-css-extract-plugin
export default {"container":"ErrorElement_container__W7y+9","main":"ErrorElement_main__Nr+P0","imageContainer":"ErrorElement_imageContainer__Y4QmB"};